import { Col, Row } from 'react-bootstrap';
import { AiOutlineMinusCircle } from 'react-icons/ai';
import { Button } from 'ypf-pas-general-ui-components';
import PropTypes from 'prop-types';

import LinePositionName from '../WorkReports/LinePositionName/LinePositionName';
import { LineValuesTemplate } from '../../utils/globalPropTypes';

const LineRowTemplate = (props) => {
  const { amount, line, position, templateComponent, handleClick, editComponent, isSDS } = props;

  return (
    <>
      <div className="line_row_wrapper">
        <Row className="d-flex align-items-center ">
          {(templateComponent || editComponent) && (
            <>
              <LinePositionName
                columnNumber={!isSDS ? 4 : 5}
                description={position.descripcionYClicPosicion}
                idWorkLine={line.idLinea}
                lineId={line.idLinea}
                name={position.nombre}
              />
              <LinePositionName
                columnNumber={!isSDS ? 3 : 4}
                description={line.descripcionYClicLinea}
                idWorkLine={line.idLinea}
                lineId={line.idLinea}
                name={line.nombre}
              />
              <Col className="justify-content-center d-flex" sm={1}>
                {line.unidadMedida}
              </Col>
              <Col className="justify-content-center d-flex" sm={1}>
                {amount}
              </Col>
              {!isSDS && (
                <>
                  <Col className="justify-content-center d-flex" sm={1}>
                    {line.onCall ? 'SI' : 'NO'}
                  </Col>
                  <Col className="justify-content-center d-flex" sm={1}>
                    {line.mensualizada ? 'SI' : 'NO'}
                  </Col>
                </>
              )}
              <Col sm={1}>
                <Button
                  colorIcon="danger"
                  disabled={false}
                  fontSizeLabel="15px"
                  icon={AiOutlineMinusCircle}
                  onClick={() => handleClick(line.idLinea, position.idPosition)}
                  sizeIcon="24px"
                  type="button"
                  variant="light-gray"
                  widthButton="40px"
                />
              </Col>
            </>
          )}
        </Row>
      </div>
    </>
  );
};

LineRowTemplate.propTypes = {
  line: LineValuesTemplate,
  position: PropTypes.shape({
    id: PropTypes.number,
    idPosition: PropTypes.number,
    nombre: PropTypes.string,
    descripcionSapPosicion: PropTypes.string,
    descripcionYClicPosicion: PropTypes.string,
    numeroPosicion: PropTypes.number
  }),
  templateComponent: PropTypes.bool,
  handleClick: PropTypes.func,
  editComponent: PropTypes.bool,
  isSDS: PropTypes.bool,
  amount: PropTypes.string
};

LineRowTemplate.defaultProps = {
  line: {},
  position: {},
  templateComponent: false,
  handleClick: () => {
    /* empty */
  },
  editComponent: false,
  isSDS: false,
  amount: ''
};
export default LineRowTemplate;
